import { render, staticRenderFns } from "./wxxiangqingPre.vue?vue&type=template&id=64655f10"
import script from "./wxxiangqingPre.vue?vue&type=script&lang=js"
export * from "./wxxiangqingPre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports